<template>
  <div :bordered="false">
    <div class="table-page-search-wrapper">

      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="12">
          <a-col :md="10" :sm="10">
            <a-form-item :label="'ApplyDate'">
              <a-range-picker
                v-model="queryParam.lendingTime"
                format="YYYY-MM-DD"
                style="width: 100%;"/>
            </a-form-item>
          </a-col>
          <a-col :md='8' :sm='8'>
            <a-form-item :label="'ProductType'">
              <a-select mode='multiple'
                        v-model='queryParam.appSsids'
              >
                <a-select-option v-for='item in appList' :key='item.appssid'>
                  {{ item.appName }}
                </a-select-option>
              </a-select>

            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="'SettledType'">
              <a-select default-value="" style="width: 120px" v-model="queryParam.settleType2">
                <a-select-option value="">
                  All
                </a-select-option>
                <a-select-option value="1">
                  Early Settlement
                </a-select-option>
                <a-select-option value="2">
                  Same Day Settlement
                </a-select-option>
                <a-select-option value="3">
                  Overdue Settlement
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="'SettledType'">
              <a-select default-value="" style="width: 120px" v-model="queryParam.settleType">
                <a-select-option value="">
                  All
                </a-select-option>
                <a-select-option value="4">
                  Extension Settlement
                </a-select-option>
                <a-select-option value="-4">
                  Non-extension Settlement
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="'ProductType'">
              <a-select default-value="" style="width: 120px" v-model="queryParam.appInfoType">
                <a-select-option value="">
                  All
                </a-select-option>
                <a-select-option value="1">
                  Main Package Product
                </a-select-option>
                <a-select-option value="2">
                  Multi-loan Product
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="'Order Type'">
              <a-select default-value="" style="width: 120px" v-model="queryParam.orderLoanType">
                <a-select-option value="">
                  All
                </a-select-option>
                <a-select-option value="1">
                  First Loan
                </a-select-option>
                <a-select-option value="2">
                  Repeat Loan
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t('order.applicationDeadline')">
              <a-select default-value="" style="width: 190px" v-model="queryParam.deadlineConfigValue">
                <a-select-option v-for="item in deadlineConfigList" :key="item.itemValue">
                  {{ item.itemText }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="3" :sm="4">
            <a-form-item :label="'Fee Rate'">
              <a-input :placeholder="$t('enter') + ' Fee Rate'" v-model="queryParam.serviceFee"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('search') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('reset') }}</a-button>
              <!--<a-button type="primary" @click="downLoadData('')" icon="download" style="margin-left: 8px">Export</a-button>-->
            </span>
          </a-col>
        </a-row>
      </a-form>


      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        bordered>
      </a-table>


    </div>
    <v-modal
        v-model="visible"
        :title="$t('order.collectionDetail')">
        <div style="padding: 20px;">
            <collection-detail
              v-if="visible"
              :orderId="orderId"
              :custInfoId="custInfoId"
              :taskId="taskId"
              :auditDrawer="false"
              @close="visible = false;"/>
        </div>
    </v-modal>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import {getApplist, reborrowCount, reborrowCountForSubmit} from '@/webpublicapi/order'
import Dict from '../modules/Dict';
import DictSelect from '../modules/DictSelect';
import exportFile from '@/webpublicapi/exportFile'
import moment from 'moment'
import vModal from '../modules/Modal';
import {getAllDeadlineConfig} from "@/webpublicapi/deadlineConfig";
const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  COLLECTION: 'collection.',
}

export default {
  name: 'reborrowCount',
  components: {
    Dict,
    DictSelect,
    vModal,
  },
  data () {
    return {
      I18N_KEY,
      toggleSearchStatus:false,
      visible: false,
      orderId: undefined,
      custInfoId: undefined,
      taskId: undefined,
      // Pagination params
      form: {
        pageNum: 1,
        pageSize: 30,
      },
      total: 0,
      dataSource: [],
      deadlineConfigList: [],
      appList: [],
      // Query conditions
      queryParam: {
        "appssid":"",
        "serviceFee":"",
        "duration":"",
        'appSsids': '',
        'orderLoanType': '',
        'appInfoType': ''
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns () {
      return [
        {
          title:  'Actual Repayment Date',
          align: 'left',
          dataIndex: 'timeStr'
        },
        {
          title: 'Settled Transaction Count',
          align: 'left',
          dataIndex: 'countSettleOrder'
        },
        {
          title: 'Repayment Same Day Reborrow',
          align: 'left',
          dataIndex: 'curReborrowCount'
        },
        {
          title: 'RepaymentPage 2DaysReborrow',
          align: 'left',
          dataIndex: 'reborrowCount2'
        },
        {
          title: 'RepaymentPage 3DaysReborrow',
          align: 'left',
          dataIndex: 'reborrowCount3'
        },
        {
          title: 'RepaymentPage 4DaysReborrow',
          align: 'left',
          dataIndex: 'reborrowCount4'
        },
        {
          title: 'RepaymentPage 5DaysReborrow',
          align: 'left',
          dataIndex: 'reborrowCount5'
        },
        {
          title: 'RepaymentPage 6DaysReborrow',
          align: 'left',
          dataIndex: 'reborrowCount6'
        },
        {
          title: 'RepaymentPage 7DaysReborrow',
          align: 'left',
          dataIndex: 'reborrowCount7'
        },
        {
          title: 'Total Reborrow Count',
          align: 'left',
          dataIndex: 'reborrowCount8'
        }
        ,
        {
          title: 'First Day Reborrow Rate',
          align: 'left',
          dataIndex: 'rate1'
        },
        {
          title: '7DayReborrowRate',
          align: 'left',
          dataIndex: 'rate7'
        },
        {
          title: '10DayReborrowRate',
          align: 'left',
          dataIndex: 'rate10'
        },
        {
          title: '15DayReborrowRate',
          align: 'left',
          dataIndex: 'rate15'
        },
        {
          title: 'ReborrowRate',
          align: 'left',
          dataIndex: 'rate'
        }



      ]
    },
  },
  created () {
    this.getDict();
    this.loadData();
    getAllDeadlineConfig().then(res => {
      this.deadlineConfigList = res.data || [];
    });
    getApplist().then(res => {
      this.appList = [];
      this.appInList = res.data || [];
      for(var i = 0 ; i < this.appInList.length ; i ++){
        if(this.appInList[i].appssid != ''){
          this.appList.push(this.appInList[i]);
        }
      }
    });
  },
  methods: {
    handleToggleSearch(){
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    searchQuery () {
      this.loadData()
    },
    loadData (arg) {
      // Load data If params passed1Then load first page content
      // if (arg === 1) {
      //   this.form.pageNum = 1
      // }
      this.loading = true
      var params = this.getQueryParams()// Query conditions
      reborrowCountForSubmit(Object.assign({}, params)).then((res)=>{
        if(res.code===1000){
          // this.total = res.data.total
          this.dataSource = res.data || [];

          for(var i = 0 ; i < this.dataSource.length ; i++){
            var dataIn = this.dataSource[i];
            // dataIn.rate = (dataIn.reborrowCount8 / dataIn.countSettleOrder).toFixed(2);
          }

        }else{
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
            this.loading = false;
            this.$message.error(e.message);
      })
    },
    transformTime (time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow (str) {
        return str && str.toLocaleLowerCase();
    },
    getQueryParams () {
      const { lendingTime } = this.queryParam;
      const data = {
          ...this.queryParam,
          lendingTimeStart: (lendingTime && lendingTime.length) ? this.transformTime(lendingTime[0]) : undefined,
          lendingTimeEnd : (lendingTime && lendingTime.length) ? this.transformTime(lendingTime[1]) : undefined,
      }
      delete data.applyDate;
      var param = Object.assign({}, data)

      return filterObj(param)
    },
    handleTableChange (pageNum, pageSize) {
        this.form.pageNum = pageNum;
        this.form.pageSize = pageSize;
        this.loadData();
    },
    // Reset dictionary type search box content
    searchReset () {
      var that = this
      that.queryParam.lendingTime = undefined;
      that.loadData(this.form.pageNum)
      that.queryParam.appSsids = ''
      this.queryParam.settleType = null;
    },
    changeModal (visible) {
        this.visible = visible;
    },
    downLoadData (arg2) {
      var params = this.getQueryParams(arg2)// Query conditions
      const file = {
        fileUrl: '/api/web/order/countLoanDataWithDateExcel?lendingTimeStart=' + params.lendingTimeStart + '&lendingTimeEnd=' + params.lendingTimeEnd + '&custType=' + params.custType,
        fileName: 'countLoanDataWithDateExcel.xls',
      }
      this.loading = true;
      exportFile(file).catch(e => {
        this.$message.error(e.message);
      }).finally(() => {
        this.loading = false;
      })
    }

  }
}
</script>
<style lang="less" scoped>
 @import "~@/assets/less/common.less";
</style>
